import React from "react"
import { Image } from "react-bootstrap"
import { classNames } from "../../../../helpers/classNames"
import type { GuideImageData } from "../../../../constants/types"

type GuideImageProps = {
  data: GuideImageData
  list: boolean
  preview: boolean
  full: boolean
}

export const GuideImage: React.FC<GuideImageProps> = ({ data, list, preview, full }) => {
  const classes = classNames({
    "image-container": true,
    list,
    preview,
    fullsize: full
  })

  return (
    <div className={classes}>
      <Image src={data.url} />
    </div>
  )
}
